import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import useTable from "../useTable";
import Controls from "../controls/Controls";
import { crearBitacora } from "@/hooks/bitacora";

import { TableBody, TableRow, TableCell, InputAdornment } from "@mui/material";
import axios from "axios";
import {
  validaMonto,
  formatoMonto,
  validaSoloNumero,
  formatMoneda,
  seleccionarCampo,
} from "../../util/varios";
import moment from "moment";
import useTableFijo from "../useTableFijo";
import AgregarTipoConstruccion from "./agregarValorTipoConstruccion";

const ModalAgregarAvaluo = (props) => {
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "TIPOLOGIA",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "AREA(M2)",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "VALOR UC(M2)",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "% PLUSVALIA",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "VALOR ACTUAL(UC)",
      textAlign: "center",
    },
  ];

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [itemSelect, setItemSelect] = useState(-1);

  /*  variables de estados */

  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const anioactu = JSON.parse(localStorage.getItem("anioactu"));
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
  const [valorTotal, setValorTotal] = useState("0,00");
  const txtAreaTerrenoM = useRef();
  const txtAreaTerrenoP = useRef();
  const txtMontoTotalPetro = useRef();
  const txtMontoTotalBs = useRef();
  const txtFechaAvaluo = useRef();
  const txtValorTotalPetro = useRef();
  const txtIdAvaluo = useRef();
  const txtDescripClasterr = useRef();
  const txtValorPetro = useRef();
  const txtValorBs = useRef();
  const txtValorTotalConst = useRef();
  const txtAreaTotalMt2 = useRef();

  const txtDescrip = useRef();
  const txtValorPrivado = useRef();
  const btnCancela = useRef();
  const txtSector = useRef();
  const txtApendice = useRef();
  const txtValorMuni = useRef();
  const btnAgregar = useRef();
  const [records, setRecords] = useState([]);
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [labels, setLabels] = useState("Bs/m2");
  const [titulo, setTitulo] = useState();
  const [ultimoAvaluo, setUltimoAvaluo] = useState();
  const [cantidaDetalle, setCantidadDetalle] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idvalorterreno: "",
    apendice: "",
    sector: "",
    descripcion: "",
    valor: "",
    valorpriv: "",
    rural: 0,
  });
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [activo, setActivo] = useState(true);
  const [total, setTotal] = useState();

  const [operacion, setOperacion] = useState("0");
  const [operacionTipo, setOperacionTipo] = useState("0");
  const [idDetalle, setIdDetalle] = useState();
  const [valorPetro, setValorPetro] = useState();
  const [operacionFicha, setOperacionFicha] = useState("0");
  const [idValorTerreno, setIdValorTerreno] = useState(0);

  const blanquear = () => {
    setRecords([]);
    setActivate(false);
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.render({ idinmueble: props.idinmueble });
    blanquear();

    props.onHideCancela();
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn);

  const cancelar = () => {
    setRecords([]);
    if (operacion === 2 || operacion === 3) {
      props.render({ idinmueble: props.idinmueble });
    }
    props.onHideCancela();

    /*  blanquear() */
  };

  const onChange = (e) => {
    e.preventDefault();

    if (e.target.type === "text" || e.target.type === "textarea") {
      e.target.value = e.target.value;
      setValues({ ...values, [e.target.name]: e.target.value });
    } else {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };

  const [totalConst, setTotalConst] = useState(0);
  const [totalPetro, setTotalPetro] = useState(0);

  useEffect(() => {
    setValorTotal(totalConst + totalPetro);
  }, [totalConst, totalPetro]);

  const procesarConstruccion = (id) => {
    let endpoint = `${op.conexion}/api/catastro/actualizarconstruccion`;
    let body;

    for (let i = 0; i < records.length; i++) {
      body = {
        operacion: operacion,
        nid: operacion === 3 ? records[i].iddetalleconstruccionavaluo : 0,
        idAva: id,
        idTipo: props.dataInmueble.idtipoinmueble,
        nvalorm2: records[i].valormt2.replace(/\./g, "").replace(",", "."),
        narea: records[i].areaconstruccion.replace(/\./g, "").replace(",", "."),
        nporce: records[i].porcentajedepre.replace(/\./g, "").replace(",", "."),
        nvalor: records[i].valor.replace(/\./g, "").replace(",", "."),
        nanio: anioactu,
        cestado: "EXCCELNTE",
        descr: records[i].descrip,
      };

      axios
        .post(endpoint, body, {
          headers: {
            "x-access-token": `${token}`,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
          }
          setActivate(false);
        })
        .catch(function (error) {
          setMensaje({
            mostrar: true,
            titulo: "ERROR",
            texto: error.response.data.message,
            icono: "error",
          });

          setActivate(false);
        });
    }
  };

  const procesarAvaluo = () => {
    let endpoint = `${op.conexion}/api/catastro/actualizaravaluo/${operacion}`;
    let body;
    setActivate(true);
    var terre = [];
    terre.push({
      areaterreno:
        txtAreaTerrenoP.current.value !== ""
          ? txtAreaTerrenoP.current.value.replace(/\./g, "").replace(",", ".")
          : "0.00",
      valorm2terreno:
        txtValorPetro.current.value !== ""
          ? txtValorPetro.current.value.replace(/\./g, "").replace(",", ".")
          : "0.00",
      areaajuste: 0,
      formaajuste: 0,
      valorajustadomt2: 0,
      valorterreno:
        txtMontoTotalPetro.current.value !== ""
          ? txtMontoTotalPetro.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          : "0.00",
      idvalorterreno: idValorTerreno,
      fechaavaluo: txtFechaAvaluo.current.value,
      valorconstruccion:
        txtValorTotalConst.current.value !== ""
          ? txtValorTotalConst.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          : "0.00",
      areaconstruccion:
        txtAreaTotalMt2.current.value !== ""
          ? txtAreaTotalMt2.current.value.replace(/\./g, "").replace(",", ".")
          : "0.00",
      areamunicipal:
        txtAreaTerrenoM.current.value !== ""
          ? txtAreaTerrenoM.current.value.replace(/\./g, "").replace(",", ".")
          : "0.00",
      valorm2terrenopriv:
        txtValorPetro.current.value !== ""
          ? txtValorPetro.current.value.replace(/\./g, "").replace(",", ".")
          : "0.00",
    });

    var constru = [];
    for (let i = 0; i < records.length; i++) {
      constru.push({
        iddetalleconstruccionavaluo:
          operacion !== 1 ? records[i].iddetalleconstruccionavaluo : 0,
        idtipologia: operacion === 1 ? 1 : records[i].idtipologia,
        valormt2: records[i].valormt2,
        areaconstruccion: records[i].areaconstruccion,
        porcentajedepre: records[i].porcentajedepre,
        valor: records[i].valor,
        anioconstruccion: anioactu,
        estadoconservacion: "EXCCELNTE",
        descrip: records[i].descrip,
      });
    }
    body = {
      //operacion: operacion,
      idinmu: props.dataInmueble.idinmueble,
      idava: operacion !== 1 ? txtIdAvaluo.current.value : 0,
      terreno: JSON.stringify(terre),
      construccion: JSON.stringify(constru),
    };

    /*if (operacion === 3) {
            procesarConstruccion(props.idAval)

        }*/

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let tipoope;
          if (props.operacion == 1) {
            tipoope = "INCLUIR";
          } else if (operacion == 2) {
            tipoope = "EDITAR";
          } else {
            tipoope = "ELIMINAR";
          }
          crearBitacora(tipoope, "avaluos", response.data[0].valret);
          if (operacion === 1) {
            //procesarConstruccion(response.data[0].avaluo_act)
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Avaluo " +
                response.data[0].valret +
                " Registrado Exitosamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Avaluo " +
                response.data[0].valret +
                " Modificado Exitosamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Avaluo " + response.data[0].valret + " Eliminado Exitosamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;

    if (sigue) {
      procesarAvaluo();
    }
  };

  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const registroPublico = (op) => (e) => {
    e.preventDefault();
    setOperacionTipo(op);

    if (op === 1) {
      if (!props.dataInmueble.idclaseinmueble) {
        setMensaje({
          mostrar: true,
          titulo: "Informacion.",
          texto:
            "el inmueble no posee una clasificación de terreno debe dirigirse al modulo de inmueble y asignarle una.",
          icono: "informacion",
        });
      } else {
        setMostrar(true);
      }
    } else {
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Esta seguro de eliminar el registro",
        icono: "confirmacion",
      });
    }
  };

  const seleccionarClaseTerreno = (id) => {
    let campos = "*";
    let nomtab = "claseterreno";
    let nomid = "idclaseterreno";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtDescripClasterr.current.value = response.data.descripcion.trim();
            txtValorPetro.current.value = formatMoneda(
              response.data.valor.toString().replace(".", ","),
              ",",
              ".",
              2,
            );
            let totalValorBS =
              parseFloat(props.valorPetro.toString()) *
              parseFloat(response.data.valor.toString());
            txtValorBs.current.value = formatMoneda(
              totalValorBS.toString().replace(".", ","),
              ",",
              ".",
              2,
            );
          }
          setActivate(false);
          calcular();
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarValorUnidad = () => {
    let campos = "*";
    let nomtab = "unidadtributaria";
    let nomid = "anio";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${anioactu}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarUltimoAvaluo = (id) => {
    let endpoint = `${op.conexion}/api/catastro/ultimoavaluo?idinmueble=${id}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setUltimoAvaluo(response.data);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const calcular = () => {
    let totalPetro =
      parseFloat(
        txtAreaTerrenoP.current.value.replace(/\./g, "").replace(",", "."),
      ) *
      parseFloat(
        txtValorPetro.current.value.replace(/\./g, "").replace(",", "."),
      );
    let totalBs =
      parseFloat(
        txtAreaTerrenoP.current.value.replace(/\./g, "").replace(",", "."),
      ) *
      parseFloat(txtValorBs.current.value.replace(/\./g, "").replace(",", "."));

    txtMontoTotalPetro.current.value = formatMoneda(
      totalPetro.toString().replace(".", ","),
      ",",
      ".",
      2,
    );
    setTotalPetro(totalPetro);
    txtMontoTotalBs.current.value = formatMoneda(
      totalBs.toString().replace(".", ","),
      ",",
      ".",
      2,
    );

    const suma2 = records.reduce((total, obj) => total + obj.valor, 0);
    let suma = suma2 + totalPetro;
    /* 
                txtValorTotalPetro.current.value = formatMoneda(suma.toString().replace(".", ","), ",", ".", 2)
         */
  };

  const calcular2 = (e) => {
    if (e.key === "Enter") {
      txtAreaTerrenoP.current.focus();
    }

    /*  const suma2 = records.reduce((total, obj) => total + obj.valor, 0);
 
         let suma = suma2 + txtMontoTotalPetro.current.value.replace(",", ".") */

    /*    txtValorTotalPetro.current.value = formatMoneda(suma.toString().replace(".", ","), ",", ".", 2)
   
    */
  };

  const seleccionarDetalleContruccion = (id) => {
    let endpoint = `${op.conexion}/api/catastro/detalleconst?idavaluo=${id}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let total = 0;
          let totalMt2 = 0;
          let totalPetro = 0;
          setRecords(response.data);
          for (let i = 0; i < response.data.length; i++) {
            total = parseFloat(total) + parseFloat(response.data[i].valor);
            totalMt2 =
              parseFloat(totalMt2) + parseFloat(response.data[i].valormt2);
            totalPetro =
              parseFloat(totalPetro) +
              parseFloat(response.data[i].areaconstruccion);
          }
          setTotal(total);

          let petro = parseFloat(totalPetro) + parseFloat(total);
          txtAreaTotalMt2.current.value = formatMoneda(
            totalMt2.toString().replace(".", ","),
            ",",
            ".",
            2,
          );
          txtValorTotalConst.current.value = formatMoneda(
            total.toString().replace(".", ","),
            ",",
            ".",
            2,
          );
          setTotalConst(total);
          //  txtValorTotalPetro.current.value = formatMoneda(petro.toString().replace(".", ","), ",", ".", 2)
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarRegistro = (id) => {
    let campos = "*";
    let nomtab = "avaluo";
    let nomid = "idavaluo";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log("hola como estas?");

          txtIdAvaluo.current.value = response.data.idavaluo;

          txtAreaTerrenoM.current.value = formatMoneda(
            response.data.areamunicipal.toString().replace(".", ","),
            ",",
            ".",
            2,
          );
          txtAreaTerrenoP.current.value = formatMoneda(
            response.data.areaterreno.toString().replace(".", ","),
            ",",
            ".",
            2,
          );
          txtFechaAvaluo.current.value = moment
            .utc(response.data.fechaavaluo)
            .format("YYYY-MM-DD");
          seleccionarDetalleContruccion(id);
          setIdValorTerreno(response.data.idvalorterreno);

          let totalPetro =
            parseFloat(response.data.areaterreno) *
            parseFloat(
              txtValorPetro.current.value.replace(/\./g, "").replace(",", "."),
            );
          let totalBs =
            parseFloat(response.data.areaterreno) *
            parseFloat(
              txtValorBs.current.value.replace(/\./g, "").replace(",", "."),
            );

          txtMontoTotalPetro.current.value = formatMoneda(
            totalPetro.toString().replace(".", ","),
            ",",
            ".",
            2,
          );
          setTotalPetro(totalPetro);

          txtMontoTotalBs.current.value = formatMoneda(
            totalBs.toString().replace(".", ","),
            ",",
            ".",
            2,
          );

          let total = 0;
          for (let i = 0; i < records.length; i++) {
            total = parseFloat(total) + parseFloat(records[i].valor);
          }

          const suma2 = records.reduce((total, obj) => total + obj.valor, 0);

          let suma = txtValorTotalConst.current.value.replace(",", ".") + suma2;

          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }

    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");
    if (event.key === "Enter") {
      if (event.target.name === "municipal") {
        txtAreaTerrenoP.current.focus();
      } else if (event.target.name === "privado") {
        calcular();
        btnAgregar.current.focus();
      }
    }
    return formatMoneda(e);
  };

  const agregarConstruccion = (data) => {
    var datos = [...records];
    setMostrar(false);
    if (operacionTipo === 1) {
      datos.push(data);

      setRecords(datos);
      let total = 0;
      let totalMt2 = 0;
      let totalPetro = 0;

      for (let i = 0; i < datos.length; i++) {
        total = parseFloat(total) + parseFloat(datos[i].valor);
        totalMt2 = parseFloat(totalMt2) + parseFloat(datos[i].valormt2);
        totalPetro =
          parseFloat(totalPetro) + parseFloat(datos[i].areaconstruccion);
      }
      let petro = parseFloat(totalPetro) + parseFloat(total);
      txtAreaTotalMt2.current.value = formatMoneda(
        totalMt2.toString().replace(".", ","),
        ",",
        ".",
        2,
      );
      txtValorTotalConst.current.value = formatMoneda(
        total.toString().replace(".", ","),
        ",",
        ".",
        2,
      );
      setTotalConst(total);
    } else if (operacionAvaluo === 3) {
    }

    //   txtValorTotalPetro.current.value = formatMoneda(petro.toString().replace(".", ","), ",", ".", 2)
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    let data = [];
    for (let i = 0; i < records.length; i++) {
      if (parseInt(i) !== parseInt(itemSelect)) {
        data.push(records[i]);
      }
    }
    setRecords(data);
    let total = 0;
    let totalMt2 = 0;
    let totalPetro = 0;

    for (let i = 0; i < data.length; i++) {
      total = parseFloat(total) + parseFloat(data[i].valor);
      totalMt2 = parseFloat(totalMt2) + parseFloat(data[i].valormt2);
      totalPetro =
        parseFloat(totalPetro) + parseFloat(data[i].areaconstruccion);
    }
    let petro = parseFloat(totalPetro) + parseFloat(total);
    txtAreaTotalMt2.current.value = formatMoneda(
      totalMt2.toString().replace(".", ","),
      ",",
      ".",
      2,
    );
    txtValorTotalConst.current.value = formatMoneda(
      total.toString().replace(".", ","),
      ",",
      ".",
      2,
    );
    setTotalConst(total);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarValorUnidad();
        if (props.idClaseTerr) {
          seleccionarClaseTerreno(props.idClaseTerr);
        }
        seleccionarUltimoAvaluo(props.dataInmueble.idinmueble);

        if (props.operacion !== 1) {
          /*  calcular() */
          seleccionarRegistro(props.idAval);
        } else {
          txtFechaAvaluo.current.value = moment
            .utc(fechasistema)
            .format("YYYY-MM-DD");
          txtAreaTotalMt2.current.value = "0,00";
          txtValorTotalConst.current.value = "0,00";
          txtAreaTerrenoM.current.value = "0,00";
          txtAreaTerrenoP.current.value = "0,00";
          // txtValorTotalPetro.current.value = '0,00'
        }
        setOperacion(props.operacion);
      }}
    >
      <Modal.Header className="azulGradiant">
        <Modal.Title style={{ color: "#fff" }}>
          Actualización de Valoración Econoimca de Inmuebles Urbanos
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AgregarTipoConstruccion
          render={seleccionarDetalleContruccion}
          operacionAvaluo={operacion}
          show={mostrar}
          cantidad={cantidaDetalle}
          onHideCancela={() => {
            setMostrar(false);
          }}
          operacion={operacionTipo}
          dataInmueble={props.dataInmueble}
          valorPetro={props.valorPetro}
          agregar={agregarConstruccion}
          idDetalle={idDetalle}
          idAval={props.idAval}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted></Dimmer>

        <div className="col-md-12 row mx-auto border-azul rounded py-2">
          <div className="input-group input-group-sm mb-2 col-md-2">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Código:
            </span>
            <input
              ref={txtIdAvaluo}
              disabled
              type="text"
              className="form-control text-right"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
          <div className="col-md-7"></div>
          <div className="input-group input-group-sm mb-2 col-md-3">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Fecha Avalúo:
            </span>
            <input
              type="date"
              ref={txtFechaAvaluo}
              disabled
              className="form-control text-right"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
          <div className="mb-2 col-md-8">
            <label className="form-label">Descripción</label>
            <input
              type="text"
              ref={txtDescripClasterr}
              disabled
              className="form-control form-control-sm"
            />
          </div>
          <div className="mb-2 col-md-2">
            <label className="form-label">Valor(Petros)</label>
            <input
              disabled
              type="text"
              ref={txtValorPetro}
              className="form-control text-right form-control-sm"
            />
          </div>
          <div className="mb-2 col-md-2">
            <label className="form-label">Valor(Bs./m2)</label>
            <input
              disabled
              ref={txtValorBs}
              type="text"
              className="form-control text-right form-control-sm"
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-5">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Area Terreno Municipal(m2):
            </span>
            <input
              type="text"
              ref={txtAreaTerrenoM}
              disabled={
                operacion === 1 ? false : operacion === 2 ? false : true
              }
              //onChange={handleInputMontoChange}
              onFocus={seleccionarCampo}
              onBlur={handleInputMontoChange}
              onKeyUp={handleInputMontoChange}
              //onKeyUp={calcular2}
              //onBlur={calcular2}
              autoComplete="off"
              id="areaterreno"
              name="municipal"
              className="form-control text-right"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
          <div className="col-md-7"></div>
          <div className="input-group input-group-sm mb-2 col-md-5">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Area Terreno Privado(m2):
            </span>
            <input
              type="text"
              ref={txtAreaTerrenoP}
              //onChange={handleInputMontoChange}
              onFocus={seleccionarCampo}
              onBlur={handleInputMontoChange}
              onKeyUp={handleInputMontoChange}
              disabled={
                operacion === 1 ? false : operacion === 2 ? false : true
              }
              name="privado"
              //onKeyUp={calcular}
              //onBlur={calcular}
              autoComplete="off"
              className="form-control text-right"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
          <div className="col-md-7"></div>

          <div className="input-group input-group-sm mb-2 col-md-5">
            <span
              className="input-group-text bg-transparent border-0"
              id="inputGroup-sizing-sm"
            >
              Monto Total (UC):
            </span>
            <input
              type="text"
              ref={txtMontoTotalPetro}
              disabled
              className="form-control text-right bg-transparent border-0"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
            <span
              className="input-group-text bg-transparent border-0"
              id="inputGroup-sizing-sm"
            >
              UC
            </span>
          </div>
          <div className="col-md-7"></div>
          <div className="input-group input-group-sm mb-2 col-md-5">
            <span
              className="input-group-text bg-transparent border-0"
              id="inputGroup-sizing-sm"
            >
              Monto Total(Bs):
            </span>
            <input
              type="text"
              ref={txtMontoTotalBs}
              disabled
              className="form-control text-right bg-transparent border-0"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
            <span
              className="input-group-text bg-transparent border-0"
              id="inputGroup-sizing-sm"
            >
              Bs
            </span>
          </div>
          <div className="col-md-7"></div>

          <fieldset className=" row col-md-12 mt-2 mb-3 border-azul row rounded mx-auto d-flex justify-content-between">
            <legend className="float-none w-auto ">
              Valoración de la Construcción
            </legend>
            <div className="col-md-11 px-0">
              <TblContainer
                container={{
                  height: 150,
                  width: "100%",
                  overflow: "auto",
                  padding: "2px",
                }}
              >
                <TblHead />

                <tbody>
                  {records &&
                    records.map((item, index) => (
                      <tr
                        disabled={operacion === 4 ? true : false}
                        style={{
                          padding: "0",
                          cursor: "pointer",
                          background:
                            itemSelect === index ? "lightskyblue" : "white",
                          pointerEvents:
                            operacion === 1 || operacion === 2
                              ? "cursor"
                              : "none",
                        }}
                        onClick={seleccionarFila(index)}
                      >
                        <td style={{ fontSize: "10px", textAlign: "center" }}>
                          {item.descrip}
                        </td>
                        <td style={{ fontSize: "10px", textAlign: "center" }}>
                          {formatMoneda(
                            item.valormt2.toString().replace(".", ","),
                            ",",
                            ".",
                            2,
                          )}
                        </td>
                        <td style={{ fontSize: "10px", textAlign: "center" }}>
                          {formatMoneda(
                            item.areaconstruccion.toString().replace(".", ","),
                            ",",
                            ".",
                            2,
                          )}
                        </td>
                        <td style={{ fontSize: "10px", textAlign: "center" }}>
                          {formatMoneda(
                            item.porcentajedepre.toString().replace(".", ","),
                            ",",
                            ".",
                            2,
                          )}
                        </td>
                        <td style={{ fontSize: "10px", textAlign: "center" }}>
                          {formatMoneda(
                            item.valor.toString().replace(".", ","),
                            ",",
                            ".",
                            2,
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </TblContainer>
              {/*<TblPagination />*/}
            </div>
            <div className="col-md-1 row">
              <div className="col-md-12 my-0 mx-auto">
                <button
                  onClick={registroPublico(1)}
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={btnAgregar}
                  className="btn btn-sm btn-primary rounded-pill my-1 mx-auto"
                >
                  <i className="fas fa-plus"> </i>{" "}
                </button>

                <button
                  onClick={registroPublico(3)}
                  //disabled={activo}
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  className="btn btn-sm btn-danger rounded-pill my-1 mx-auto"
                >
                  <i className="fas fa-trash"> </i>{" "}
                </button>
              </div>
            </div>
          </fieldset>

          <div className="col-md-4"></div>
          <div className="input-group input-group-sm mb-2 col-md-4">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Area Total Mt2 Construcción
            </span>
            <input
              type="text"
              ref={txtAreaTotalMt2}
              disabled
              className="form-control text-right"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
          <div className="input-group input-group-sm mb-2 col-md-4">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Valor Total Construcción:
            </span>
            <input
              type="text"
              ref={txtValorTotalConst}
              disabled
              className="form-control text-right"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
          <div className="col-md-8"></div>
          <div className="input-group input-group-sm mb-2 col-md-4">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Valor Total Avalúo UC:
            </span>
            <input
              type="text"
              disabled
              //  ref={txtValorTotalPetro}
              className="form-control text-right"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={
                valorTotal !== 0
                  ? formatMoneda(
                      valorTotal.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2,
                    )
                  : "0,00"
              } // Mostrar el valor total en el input
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          onClick={onChangeValidar}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>

        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill"
        >
          <i className="fa"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAgregarAvaluo;
